import React, { useState, useEffect } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition"; 
import {
  askQuestionWithAIBot,
  getStartedWithBot,
  transliterateToHindi,
} from "../../api/dashboard"; 
import bot from "../../images/bot.png";
import close from "../../images/close.png";
import li from "../../images/progress.png";
import lady from "../../images/logo.png";
import send from "../../images/send.png";  

export default function AIChatBot() {
  const { transcript, listening, resetTranscript } = useSpeechRecognition();
  const [isOpen, setIsOpen] = useState(false); // 👈 controls popup visibility
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [botSpeech, setBotSpeech] = useState("");
  const [speechKey, setSpeechKey] = useState(0);
  const [ttsEnabled, setTtsEnabled] = useState(false); // unlocks after user click
  const [speakingIndex, setSpeakingIndex] = useState(null);
  const [manualPlay, setManualPlay] = useState(false);
  const [micActive, setMicActive] = useState(false);
  const [userInput, setUserInput] = useState("");

  const speakNow = (text) => {
    if (!ttsEnabled || !window.speechSynthesis) return;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "hi-IN";
    utterance.rate = 1;
    utterance.pitch = 1;

    // Optional: try to find a Hindi voice
    const voices = window.speechSynthesis.getVoices();
    const hindiVoice = voices.find((v) => v.lang.includes("hi-IN"));
    if (hindiVoice) utterance.voice = hindiVoice;

    window.speechSynthesis.cancel(); // stop any current speech
    window.speechSynthesis.speak(utterance);
  };

  // Fetch welcome message only once when opened
  useEffect(() => {
    if (isOpen && messages.length === 0) {
      getStartedMessage();
    }
  }, [isOpen]);

  const getStartedMessage = async () => {
    setLoading(true);
    try {
      const res = await getStartedWithBot();
      if (res.status === 200) {
        const mesg = res.data.message;
        const text = { sender: "bot", text: mesg };
        setMessages([text]);
        setBotSpeech(mesg);
        setSpeechKey((prev) => prev + 1);
        handleSpeechToggle(0, mesg);
      }
    } catch (err) {
      console.error("Error fetching welcome message:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleStart = () => {
    resetTranscript();
    setTtsEnabled(true);
    SpeechRecognition.startListening({ continuous: true, language: "hi-IN" });
  };

  const handleStop = async () => {
    SpeechRecognition.stopListening();
    if (!transcript.trim()) return;

    const userMessage = { sender: "user", text: transcript };
    setMessages((prev) => [...prev, userMessage]);
    setLoading(true);

    try {
      const res = await askQuestionWithAIBot({ query_hi: transcript });
      const botText = res.data.reply || "माफ़ कीजिए, मैं समझ नहीं पाई।";
      const botMessage = { sender: "bot", text: botText };
      setMessages((prev) => {
        const newMessages = [...prev, botMessage];
        // automatically play the bot speech for this message
        const index = newMessages.length - 1;
        setSpeakingIndex(index);
        setManualPlay(false); // auto-play
        handleSpeechToggle(index, botText); // pass index if your speak function supports it
        return newMessages;
      });

      setBotSpeech(botText);
      setSpeechKey((prev) => prev + 1);
      // speakText(botText);
    } catch (err) {
      console.error("Axios fetch error:", err);

      const errorMsg =
        "अभी कुछ दिक्कत आ रही है, कृपया थोड़ी देर बाद फिर से कोशिश करें।";
      setMessages((prev) => [...prev, { sender: "bot", text: errorMsg }]);
      setBotSpeech(errorMsg);
      setSpeechKey((prev) => prev + 1);
      speakText(errorMsg);
    } finally {
      setLoading(false);
      resetTranscript();
    }
  };
  const handleSpeechToggle = (index, text) => {
    if (!ttsEnabled) return;

    // If the same message is already playing, stop it
    if (speakingIndex === index && manualPlay) {
      window.speechSynthesis.cancel();
      setManualPlay(false);
      setSpeakingIndex(null);
      return;
    }

    // Stop current speech and play this one
    window.speechSynthesis.cancel();

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "hi-IN";
    utterance.rate = 1;
    utterance.pitch = 1;

  const voices = window.speechSynthesis.getVoices();

  const femaleHindiVoice =
    voices.find(v => v.name.includes("Microsoft Kalpana")) ||
    voices.find(v => v.name.includes("Google हिन्दी")) ||
    voices.find(v => v.lang === "hi-IN");

    console.log("female voice",femaleHindiVoice)

  if (femaleHindiVoice) {
    utterance.voice = femaleHindiVoice;
  }

    utterance.onend = () => {
      setManualPlay(false);
      setSpeakingIndex(null);
    };

    window.speechSynthesis.speak(utterance);
    setManualPlay(true);
    setSpeakingIndex(index);
  };

  const speakText1 = (text) => {
    if (!ttsEnabled || !window.speechSynthesis) return;

    window.speechSynthesis.cancel(); // stop any current speech

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "hi-IN";
    utterance.rate = 1;
    utterance.pitch = 1.1;

    const voices = window.speechSynthesis.getVoices();
    const hindiVoice = voices.find((v) => v.lang.includes("hi-IN"));
    if (hindiVoice) utterance.voice = hindiVoice;

    window.speechSynthesis.speak(utterance);
  };
const speakText = (text) => {
   console.log("female voice",ttsEnabled)
  if (!ttsEnabled || !window.speechSynthesis) return;

  window.speechSynthesis.cancel();

  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "hi-IN";
  utterance.rate = 1;
  utterance.pitch = 1;

  const voices = window.speechSynthesis.getVoices();

  const femaleHindiVoice =
    voices.find(v => v.name.includes("Microsoft Kalpana")) ||
    voices.find(v => v.name.includes("Google हिन्दी")) ||
    voices.find(v => v.lang === "hi-IN");

    console.log("female voice",femaleHindiVoice)

  if (femaleHindiVoice) {
    utterance.voice = femaleHindiVoice;
  }

  window.speechSynthesis.speak(utterance);
};
useEffect(() => {
  speechSynthesis.onvoiceschanged = () => {
    console.log(speechSynthesis.getVoices());
  };
}, []);
  useEffect(() => {
    // listening comes from useSpeechRecognition
    if (!listening && micActive) {
      // User stopped speaking
      setMicActive(false);
      if (transcript.trim()) {
        handleStop(); // send transcript to API
      }
    }
  }, [listening]); // triggers whenever listening changes
  const handleTextSubmit1 = async () => {
    const text = userInput.trim();
    if (!text) return;

    const userMessage = { sender: "user", text };
    setMessages((prev) => [...prev, userMessage]);
    setUserInput("");
    setLoading(true);

    try {
      const res = await askQuestionWithAIBot({ query_hi:text }); // your axios function
      const botText = res.data.answer_hi || "माफ़ कीजिए, मैं समझ नहीं पाई।";
      const botMessage = { sender: "bot", text: botText };
      setMessages((prev) => [...prev, botMessage]);
      setBotSpeech(botText);
      setSpeechKey((prev) => prev + 1);
      speakText(botText); // auto play TTS
    } catch (err) {
      console.error("Axios error:", err);
      const errorMsg =
        "अभी कुछ दिक्कत आ रही है, कृपया थोड़ी देर बाद फिर से कोशिश करें।";
      setMessages((prev) => [...prev, { sender: "bot", text: errorMsg }]);
      setBotSpeech(errorMsg);
      setSpeechKey((prev) => prev + 1);
      speakText(errorMsg);
    } finally {
      setLoading(false);
    }
  };
  const handleTextSubmit = async () => {
    if (!userInput.trim()) return;

    // Convert English -> Hindi using Google Input Tools
    const hindiText = await transliterateToHindi(userInput);

    const userMessage = { sender: "user", text: hindiText };
    setMessages((prev) => [...prev, userMessage]);
    setUserInput("");
    setLoading(true);

    try {
      const res = await askQuestionWithAIBot({ query_hi: hindiText }); 
      const botText = res.data.answer_hi || "माफ़ कीजिए, मैं समझ नहीं पाई।";
      // setMessages((prev) => [...prev, { sender: "bot", text: botText }]);
      setMessages((prev) => {
        const newMessages = [...prev, { sender: "bot", text: botText }];
        // automatically play the bot speech for this message
        const index = newMessages.length - 1;
        setSpeakingIndex(index);
        setManualPlay(false); // auto-play
        handleSpeechToggle(index, botText); // pass index if your speak function supports it
        return newMessages;
      });
      // speakText(botText);
    } catch (err) {
      const errorMsg =
        "अभी कुछ दिक्कत आ रही है, कृपया थोड़ी देर बाद फिर से कोशिश करें।";
      setMessages((prev) => [...prev, { sender: "bot", text: errorMsg }]);
      speakText(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      // style={{
      //   backgroundImage: `url(${lady})`, // `lady` is the variable holding your image source
      //   backgroundSize: "contain", // Ensures the background image covers the whole area
      //   backgroundRepeat: "no-repeat", // Prevents the image from repeating
      //   backgroundPosition: "center", // Centers the image
      //   height: "auto", // Full viewport height
      //   width: "100%", // Full width of the screen
      //   position: "absolute", // Keeps the background fixed
      //   top: 0,
      //   bottom: 0,
      //   left: 0,
      //   right: 0, // Makes sure the image stretches to fill the entire screen
      // }}
    >
      {/* 🔘 Floating Button */}
      <div
        onClick={() => {
          handleSpeechToggle(speakingIndex, "");
          // 🧠 1. Stop whatever speech is playing
          window.speechSynthesis.cancel();

          // 🎙️ 2. Start listening immediately
          resetTranscript();
          setIsOpen(!isOpen);
          setTtsEnabled(true); // unlock speech on first user click
        }}
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          backgroundColor: "#007bff",
          color: "#fff",
          width: 60,
          height: 60,
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: 28,
          cursor: "pointer",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
          zIndex: 1000,
        }}
      >
        {isOpen ? (
          <img src={close} style={{ width: "30px", height: "30px" }} />
        ) : (
          <img src={bot} style={{ width: "60px", height: "60px" }} />
        )}
      </div>

      {/* 💬 Chat Popup */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            bottom: 90,
            right: 20,
            width: 450,
            height: 600,
            backgroundColor: "#fff",
            borderRadius: 10,
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#007bff",
              color: "#fff",
              padding: "12px 16px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            <img src={lady} style={{ width: "70px" }} />
            {/* Voice Chat Assistant */}
          </div>

          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: 10,
              background: "#f9f9f9",
            }}
          >
            {messages.length === 0 && (
              <p style={{ textAlign: "center", color: "#777" }}>
                Initializing assistant...
              </p>
            )}

            {messages.map((msg, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  justifyContent:
                    msg.sender === "user" ? "flex-end" : "flex-start",
                  marginBottom: 8,
                }}
              >
                <div
                  style={{
                    background: msg.sender === "user" ? "#007bff" : "#e5e5ea",
                    color: msg.sender === "user" ? "#fff" : "#000",
                    padding: "8px 12px",
                    borderRadius: 20,
                    maxWidth: "95%",
                    wordBreak: "break-word",
                  }}
                  // onClick={()=>speakNow(msg.text)}
                >
                  {msg.text}
                  {msg.sender === "bot" && (
                    <button
                      onClick={() => handleSpeechToggle(i, msg.text)}
                      style={{
                        background: "transparent",
                        border: "none",
                        color: "#007bff",
                        cursor: "pointer",
                        fontSize: 12,
                        marginTop: 4,
                        display: "block",
                      }}
                    >
                      {speakingIndex === i && manualPlay
                        ? "🔇 बंद करें"
                        : "🔊 सुनें"}
                    </button>
                  )}
                </div>
              </div>
            ))}

            {loading && (
              <p
                style={{
                  color: "#777",
                  fontStyle: "italic",
                  margin: "10px 0",
                }}
              >
                Bot is typing...
              </p>
            )}
          </div>

          {micActive && (
            <div
              className="text-center"
              style={{
                backgroundColor: "lightgray",
                padding: 10,
                borderRadius: "5px 5px 0 0", // top-left, top-right, bottom-right, bottom-left
                border: "1px solid #ccc",
              }}
            >
              <span>{"आप बोलिए| सुन रही हूँ मैं|"}</span>
            </div>
          )}
          {/* 🎤 Mic Button */}
          {/* <div
            style={{
              display: "flex",
              padding: 10,
              borderTop: "1px solid #eee",
              background: "#fff",
            }}
          >
            <input
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              placeholder="अपना सवाल लिखें..."
              style={{
                flex: 1,
                padding: "8px 12px",
                borderRadius: 20,
                border: "1px solid #ccc",
                marginRight: 8,
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleTextSubmit();
              }}
            />
            <button
              onClick={handleTextSubmit}
              style={{
                padding: "8px 16px",
                borderRadius: 20,
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              भेजें
            </button>
          </div>

          <div
            style={{
              padding: 10,
              textAlign: "center",
              borderTop: "1px solid #eee",
              background: "#fff",
            }}
          >
            <button
              onClick={() => {
                if (!micActive) {
                  // Start listening once
                  resetTranscript();
                  setMicActive(true);
                  SpeechRecognition.startListening({
                    continuous: false, // stops automatically when user stops speaking
                    language: "hi-IN",
                  });
                }
              }}
              style={{
                background: micActive ? "#dc3545" : "#d3d3d3",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: 60,
                height: 60,
                fontSize: 18,
                cursor: "pointer",
              }}
            >
              {micActive ? (
                <img src={li} style={{ width: "30px", height: "30px" }} />
              ) : (
                <img src={li} style={{ width: "30px", height: "30px" }} />
              )}
            </button>
          </div> */}
          <div
            style={{
              display: "flex",
              padding: 10,
              borderTop: "1px solid #eee",
              background: "#fff",
            }}
          >
            <input
              type="text"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              placeholder="अपना सवाल टाइप करें..."
              style={{
                flex: 1,
                padding: "8px 12px",
                borderRadius: 20,
                border: "1px solid #ccc",
                marginRight: 8,
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleTextSubmit();
              }}
            />
            {/* Mic button inside input row */}
            <button
              onClick={() => {
                handleSpeechToggle(speakingIndex, "");
                // 🧠 1. Stop whatever speech is playing
                window.speechSynthesis.cancel();

                // 🎙️ 2. Start listening immediately
                resetTranscript();
                if (!micActive) {
                  resetTranscript();
                  setMicActive(true);
                  SpeechRecognition.startListening({
                    continuous: false, // stops automatically when user stops speaking
                    language: "hi-IN",
                  });
                }
              }}
              style={{
                background: micActive ? "#dc3545" : "#d3d3d3",
                color: "#fff",
                border: "none",
                borderRadius: "50%",
                width: 40,
                height: 40,
                fontSize: 18,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                right: 83,
                transform: "translateY(2%)",
              }}
            >
              <img src={li} style={{ width: "25px", height: "25px" }} />
            </button>

            <button
              onClick={handleTextSubmit}
              style={{
                padding: "8px 16px",
                borderRadius: 20,
                backgroundColor: "#d3d3d3",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                marginLeft: 8,
              }}
            >
              <img src={send} style={{ width: "25px", height: "25px" }} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}